<bs-page-header pageTitle="ADMIN.GLOBAL.BIN_MANAGEMENT" [breadcrumbItems]="breadcrumbItems" />
<bs-table (rowClick)="handleRowClick($event)" />
